var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ActionButton',_vm._b({on:{"click":_vm.clearFilters}},'ActionButton',{ hierarchy: _vm.hierarchy, iconLeading: _vm.iconLeading },false),[_vm._v("\n  "+_vm._s(_vm.actionLabel)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }